export default {
    car: 'CAR',
    carElectric: 'CAR_ZERO_EMISSION',
    carNoInsurance: 'CAR_NO_INSURANCE',
    mc: 'MC',
    atv: 'ATV',
    snowmobile: 'SNOWMOBILE',
    campingCar: 'CAMPING_CAR',
    campingCaravan: 'CARAVAN',
    boat: 'BOAT',
    lendo: 'CREDIT_LOAN_LENDO',
};
